<template>
  <div 
    v-if="hasRequiredData" 
    class="d-flex flex-column">
    <NavBar />
    <div class="d-flex align-items-stretch flex-grow-1">
      <SideBar :menu-items="menuItems" />
      <div class="flex-grow-1 d-flex flex-column">
        <!-- <HeaderBar /> -->
        <div class="p-3 m-3 flex-grow">
          <slot />
        </div>
      </div>
    </div>
  </div>
  <div 
    v-else 
    class="d-flex flex-column justify-content-center align-items-center">
    Loading data, please wait...
  </div>
</template>

<script>
import SideBar from 'organism/SideBar';
import NavBar from 'organism/NavBar';

import MenuItem from 'model/MenuItem';

import { getUser } from 'service/auth'
import { mapGetters, mapMutations } from 'vuex';

/**
 * The layout for the general user pages.
 */
export default {
  components: {
    SideBar, NavBar
  },
  data() {
    return {
      hasRequiredData: true,
      menuItems: [
        new MenuItem({
          label: 'Prognose Kaart',
          icon: 'map-light.svg',
          to: { name: 'home' }
        }),
        new MenuItem({
          label: 'Aanvragen',
          icon: 'file-alt-light.svg',
          to: { name: 'reports' }
        }),
        new MenuItem({
          label: 'Log uit',
          icon: 'sign-out-light.svg',
          to: { name: 'logout' }
        })
      ]
    }
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },
  async created() {
    // Check login
    // this.$router.push({ name: 'login' })
    if (!this.user) {
      this.setUser({ authenticatedUser: getUser() })
    }
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
  }
}
</script>
